import Emitter from './services/Emitter'
import { START } from './events'

let components = {}

const Scope = id => {
	let scope = {}

	// event callback
	scope.on = (name, callback) => {
		Emitter.on(name, data => {
			callback.call(scope, data)
		})
	}

	// emit an event
	scope.emit = (name, data) => {
		Emitter.emit(name, data)
	}

	// called after components and services are registered
	scope.init = callback => {
		setTimeout(callback.call(scope))
	}

	// call on application start
	scope.start = callback => {
		Emitter.on(START, () => callback.call(scope))
	}

	// print an error
	scope.error = error =>
		console.error('Application error\n', 'Location: ' + id + '\n', 'Error: "' + error + '"')

	return scope
}

const createComponent = (name, element) => {
	if (!components[name]) {
		throw new Error('Component ' + name + ' does not exist')
	}
	let scope = new Scope(name)
	components[name].call(scope, scope, element)
}

const registerComponent = (name, func) => {
	components[name] = func
}

const compile = element => {
	for (let name in components) {
		let componentElements = element.querySelectorAll('[data-component-' + name + ']')

		for (let i = 0; i < componentElements.length; ++i) {
			initiateComponent(name, componentElements[i])
		}

		if (element.hasAttribute('data-component-' + name)) {
			initiateComponent(name, element)
		}
	}
}

const initiateComponent = (name, element) => {
	if (!name) return

	if (components[name] === 'undefined') {
		console.error(
			'App Error \n',
			'Location: component ' + name + '\n',
			'Error: Component function does not exist'
		)
		return
	}
	try {
		createComponent(name, element)
	} catch (error) {
		console.error(error)
		console.error(
			'App Error \n',
			'Location: component ' + name + '\n',
			'Error: "' + error + '"'
		)
	}
}

// exports

export { registerComponent, compile }

export default el => {
	compile(el)
	setTimeout(() => Emitter.emit(START), 200)
}
